import {
  PRE_ACTIVATION_ADS_PLATFORM_GOOGLE,
  PRE_ACTIVATION_ADS_PLATFORM_LINKEDIN,
  PRE_ACTIVATION_ADS_PLATFORM_META,
  PRE_ACTIVATION_ADS_PLATFORM_TIKTOK,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_ADVANCED,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INITIAL,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INTERMEDIATE,
  PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_MIXED,
  PRE_ACTIVATION_AGENCY_MODULE_COMPETITOR_ADS,
  PRE_ACTIVATION_AGENCY_MODULE_CREATIVE,
  PRE_ACTIVATION_AGENCY_MODULE_ORGANIC_SOCIAL,
  PRE_ACTIVATION_AGENCY_MODULE_PAID_MEDIA,
} from "../../i18n/keysTranslations";

export const AGENCY_PLATFORM_META = "meta";
export const AGENCY_PLATFORM_GOOGLE = "google";
export const AGENCY_PLATFORM_TIKTOK = "tiktok";
export const AGENCY_PLATFORM_LINKEDIN = "linkedin";

export const AGENCY_PLATFORM_VALUES = [
  AGENCY_PLATFORM_META,
  AGENCY_PLATFORM_GOOGLE,
  AGENCY_PLATFORM_TIKTOK,
  AGENCY_PLATFORM_LINKEDIN,
];

export const AGENCY_MODULE_CREATIVE = "creative";
export const AGENCY_MODULE_PAID_MEDIA = "paid_media";
export const AGENCY_MODULE_ORGANIC_SOCIAL = "organic_social";
export const AGENCY_MODULE_COMPETITOR_ADS = "competitor_ads";

export const AGENCY_MODULE_VALUES = [
  AGENCY_MODULE_CREATIVE,
  AGENCY_MODULE_PAID_MEDIA,
  AGENCY_MODULE_ORGANIC_SOCIAL,
  AGENCY_MODULE_COMPETITOR_ADS,
];

export const hasPaidMediaModule = (modules) =>
  Array.isArray(modules) && modules.includes(AGENCY_MODULE_PAID_MEDIA);

export const AGENCY_MODULE_OPTIONS = [
  {
    value: AGENCY_MODULE_CREATIVE,
    labelKey: PRE_ACTIVATION_AGENCY_MODULE_CREATIVE,
  },
  {
    value: AGENCY_MODULE_PAID_MEDIA,
    labelKey: PRE_ACTIVATION_AGENCY_MODULE_PAID_MEDIA,
  },
  {
    value: AGENCY_MODULE_ORGANIC_SOCIAL,
    labelKey: PRE_ACTIVATION_AGENCY_MODULE_ORGANIC_SOCIAL,
  },
  {
    value: AGENCY_MODULE_COMPETITOR_ADS,
    labelKey: PRE_ACTIVATION_AGENCY_MODULE_COMPETITOR_ADS,
  },
];

export const PRE_ACTIVATION_OTHER_OPTION_VALUE = "other";

export const AGENCY_TEAM_FAMILIARITY_VALUES = [
  "advanced",
  "intermediate",
  "initial",
  "mixed",
];

export const AGENCY_TEAM_FAMILIARITY_OPTIONS = [
  {
    value: "advanced",
    labelKey: PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_ADVANCED,
  },
  {
    value: "intermediate",
    labelKey: PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INTERMEDIATE,
  },
  {
    value: "initial",
    labelKey: PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_INITIAL,
  },
  { value: "mixed", labelKey: PRE_ACTIVATION_AGENCY_TEAM_FAMILIARITY_MIXED },
];

export const AGENCY_PLATFORM_CONFIGS = [
  {
    value: AGENCY_PLATFORM_META,
    labelKey: PRE_ACTIVATION_ADS_PLATFORM_META,
  },
  {
    value: AGENCY_PLATFORM_GOOGLE,
    labelKey: PRE_ACTIVATION_ADS_PLATFORM_GOOGLE,
  },
  {
    value: AGENCY_PLATFORM_TIKTOK,
    labelKey: PRE_ACTIVATION_ADS_PLATFORM_TIKTOK,
  },
  {
    value: AGENCY_PLATFORM_LINKEDIN,
    labelKey: PRE_ACTIVATION_ADS_PLATFORM_LINKEDIN,
  },
];

export const AGENCY_AD_PLATFORM_OPTIONS = AGENCY_PLATFORM_CONFIGS.map(
  ({ value, labelKey }) => ({ value, labelKey })
);

export const createEmptyPersonContact = () => ({
  fullName: "",
  jobTitle: "",
  email: "",
});

export const createEmptyConfirmations = () => ({
  singleBrand: false,
  accountAdmin: false,
  reschedule: false,
});

export const createEmptyOnboardingSession = () => ({
  startTime: "",
  endTime: "",
  uid: "",
  title: "",
});

export const mapTranslatedOptions = ({ options = [], t }) =>
  options.map((option) => ({
    value: option.value,
    label: t(option.labelKey),
  }));
